import type { ReactNode } from 'react';
import { plural } from '../../../../../shared/helpers';
import { INFO_PANEL_TYPE } from '../../../generic';

import InfoPanel from '../../../generic/InfoPanel';
import Text from '../../../generic/Text';
import styles from './dialogBodies.module.less';
import type { PackageLabelForTable } from '../../../settings/organization/general/PackageLabelsSelector/PackageLabelSelector';

/**
 * Returns the JSX for the confirmation dialog when deleting a label.
 */
export const deleteLabelDialogBody = (deletedLabel: PackageLabelForTable): ReactNode => (
  <>
    <div className={styles.header}>
      Are you sure you&apos;d like to delete the &quot;{deletedLabel.name}&quot; label?
    </div>
    {deletedLabel.packageCount ? (
      <InfoPanel type={INFO_PANEL_TYPE.WARNING}>
        This label will be removed from the <b>{deletedLabel.packageCount}</b>{' '}
        {plural(deletedLabel.packageCount, 'package')} using it.
      </InfoPanel>
    ) : (
      <InfoPanel>This label isn&apos;t used in any packages.</InfoPanel>
    )}
    <div className={styles.info}>
      <Text.Micro>Note: You must save your organization settings for this change to take effect.</Text.Micro>
    </div>
  </>
);
